import { render } from "./Accordition.vue?vue&type=template&id=d15829ac"
import script from "./Accordition.vue?vue&type=script&lang=js"
export * from "./Accordition.vue?vue&type=script&lang=js"

import "./Accordition.vue?vue&type=style&index=0&id=d15829ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__